import { h } from "../../core/dom.js";

const LABELS = { system: "Sistema", light: "Chiaro", dark: "Scuro" };
const ICONS = { system: "🖥️", light: "☀️", dark: "🌙" };

export function themePicker(theme) {
  const buttons = theme.modes.map((mode) =>
    h("button", {
      class: "btn btn-ghost theme-option",
      type: "button",
      "data-mode": mode,
      onclick: () => theme.set(mode)
    }, `${ICONS[mode]} ${LABELS[mode]}`));
  const group = h("div", { class: "theme-picker", role: "group", "aria-label": "Aspetto" }, buttons);
  theme.subscribe((mode) => {
    buttons.forEach((button) => {
      const selected = button.dataset.mode === mode;
      button.classList.toggle("selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
  });
  return group;
}
